export default "__VITE_ASSET__DB1rom5Y__"